export default {
  locale: "es",
  name: "Reenvío de reservas",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "hotelTicker",
        displayName: "Ticker del motor",
        description: "Identificador del motor",
        helpText: "",
        placeholder: "Introduce un ticker del motor",
      },
      {
        fieldName: "reservationId",
        displayName: "Id de la reserva (M)",
        description: "Identificador de la reserva",
        helpText: "",
        placeholder: "Introduce un id de la reserva",
      },
    ],
  },
};
